import { Api } from '@coder-house/ch-coder-util'

const { VUE_APP_CAMPUS_SERVICE } = process.env

const CAMPUS_ROLLOUT = 'campus-rollout'
const isCoderV3 = async (courseId: string) => {
    const context = {
      context: { camada: [Number(courseId)] }
    }
    const variationList = await Api.post(`${VUE_APP_CAMPUS_SERVICE}/api/v1/feature-flag/evaluate/${CAMPUS_ROLLOUT}`, context)

    if ( variationList && variationList[courseId] === 'v3') {
      return true
    }
    return false
  }

export { isCoderV3 }